import { useMemo, useRef, useState } from 'react';

interface UseModalVisibilityProps {
  isWithoutButton?: boolean;
  isVisible?: boolean;
  onSetVisible?: (value: boolean) => void;
}

export const useModalVisibility = ({ isWithoutButton, isVisible, onSetVisible }: UseModalVisibilityProps) => {
  const [modalVisible, setModalVisible] = useState(false);

  const currentModalVisible = useMemo(() => (
    isWithoutButton && isVisible ? isVisible : modalVisible
  ), [isWithoutButton, modalVisible, isVisible]);

  const currentSetModalVisible = useMemo(() => (
    isWithoutButton && onSetVisible ? onSetVisible : setModalVisible
  ), [isWithoutButton, onSetVisible]);

  const prevModalVisibleRef = useRef(currentModalVisible);

  return {
    currentModalVisible,
    currentSetModalVisible,
    prevModalVisibleRef,
    setModalVisible,
  };
};
